import { ROUTE_NAMES } from '@/constant/routes'

// AHA-46604 — the workspace-app → presenter "return to the workspace" contract.
//
// The workspace app (embed `aha-workspace`) opens editors with a full
// top-window navigation carrying `?from=workspace`. Consumers:
//   • presentation editor backV4Action (editor.module.js) — provenance-guarded
//     history.back() or a deterministic My Files push;
//   • EmbedAppContainer — the aha-survey editor's exit sentinel picks My Files
//     over a blind history step when this signal is on the route.
// The producer lives in workspace-app's frontend/src/host/navigate.ts:
// its FROM_WORKSPACE holds the full 'from=workspace' pair; this constant is
// only the VALUE — functionally consistent, deliberately not literal mirrors.
export const WORKSPACE_FROM_QUERY = 'workspace'

// Manifest id + canonical presenter address of the workspace app (My Files
// root — the EMBED_APP route the sidebar header links to). They live here,
// not in the sidebar module, so store code can target the workspace without
// reaching into components-v2; myFilesMenu re-exports both, so sidebar
// consumers are unchanged.
export const WORKSPACE_APP_ID = 'aha-workspace'
export const myFilesRoute = () => ({
  name: ROUTE_NAMES.EMBED_APP,
  params: { appId: WORKSPACE_APP_ID, path: '' },
})

// Several editor flows `replace()` the route query wholesale (preview
// open/close, present entry/exit, AI prompt consumption), which would wipe
// the signal mid-session. Merge helper that keeps exactly the workspace
// signal alive without resurrecting anything else those sites deliberately
// clear. Gated on the VALUE: `from` is an overloaded param in this app
// (audience, invitation, requestTemplate, …) and those must stay cleared.
export const withFromQuery = (currentQuery, nextQuery = {}) => {
  const from = currentQuery && currentQuery.from
  return from === WORKSPACE_FROM_QUERY ? { ...nextQuery, from } : nextQuery
}
